import styled from "styled-components";

export const Container = styled.div`
  border-radius: 24px;
  border: 1px solid var(--Border-Default-grey100, #e8e8e8);
  background: #fff;
  padding: 32px 20px 0px 20px;
  @media (min-width: 768px) {
  border-radius: 40px;
    padding: 40px 40px 0px 40px;
  }
`;

export const LieHeader = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const LieNumber = styled.div``;

export const LieQuote = styled.div`
  color: var(--Yellow-Y500, #d16900);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  @media (min-width: 768px) {
    color: var(--Yellow-Y500, #d16900);
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-top: 1px dashed #e7e7f0;
  margin: 16px 0px;
`;

export const MainHeading = styled.div`
  color: var(--text-primary-n-600, #040222);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 24px;
  @media (min-width: 768px) {
    color: var(--text-primary-n-600, #040222);

    font-family: "Euclid Circular B";
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: -0.5px;
    text-align: left;
  }
`;

export const InfoCard = styled.div`
  border-radius: 24px;
  border: 1px solid var(--BrandColor-Primary-100, #baa5fd);
  background: var(--Surface-accent-Violet-Violet-50, rgba(153, 116, 249, 0.08));
  padding: var(--Dimensions-Space-spacing-20, 20px) var(--spacing-16px, 16px);
`;

export const InfoHeading = styled.div`
  color: var(--Text-Primary-grey600, #121212);
  text-align: center;
  font-family: var(--Typeface-family, "Euclid Circular B");
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 12px;
`;

export const DealershipsBox = styled.div`
  border-radius: var(--Dimensions-Radius-radius-2xl, 16px);
  background: var(--Surface-base-overlay, #fff);
  display: flex;
  padding: var(--spacing-16px, 16px) var(--Dimensions-Space-spacing-16, 16px)
    var(--Dimensions-Space-spacing-16, 16px)
    var(--Dimensions-Space-spacing-16, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin-top: 24px;
`;

export const DealershipsTitle = styled.div`
  color: var(--Purple-P400, #5920c5);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const DealershipItem = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const DealershipText = styled.div`
  color: var(--Neutral-N500, #36354c);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`;

export const HorizontalDivider = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px solid var(--Border-Default-grey100, #e8e8e8);
  margin: 0px 0px;
`;

export const ViewAllLink = styled.div`
  color: var(--text-primary-n-600, #040222);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;
